function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useEffect } from 'react';
import { useDropdownContext } from './context';
import cs from 'classnames';
export var DropdownMenu = function DropdownMenu(props) {
  var _dropdownRef$current$, _dropdownRef$current, _dropdownRef$current$2, _dropdownRef$current2, _props$position, _props$position2, _props$position3, _dropdownRef$current$3, _dropdownRef$current3;

  var _useDropdownContext = useDropdownContext(),
      menuRef = _useDropdownContext.menuRef,
      open = _useDropdownContext.open,
      allItems = _useDropdownContext.allItems,
      dropdownRef = _useDropdownContext.dropdownRef;

  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      windowHeight = _useState2[0],
      setWindowHeight = _useState2[1];

  var _useState3 = useState(0),
      _useState4 = _slicedToArray(_useState3, 2),
      menuHeight = _useState4[0],
      setMenuHeight = _useState4[1];

  var _useState5 = useState('hidden'),
      _useState6 = _slicedToArray(_useState5, 2),
      visibility = _useState6[0],
      setVisibility = _useState6[1];
  /**
   * Place the dropdown menu above toggle if we are close to the bottom of the page.
   */


  var dropdownPosition = ((_dropdownRef$current$ = (_dropdownRef$current = dropdownRef.current) === null || _dropdownRef$current === void 0 ? void 0 : _dropdownRef$current.offsetTop) !== null && _dropdownRef$current$ !== void 0 ? _dropdownRef$current$ : 0) + ((_dropdownRef$current$2 = (_dropdownRef$current2 = dropdownRef.current) === null || _dropdownRef$current2 === void 0 ? void 0 : _dropdownRef$current2.offsetHeight) !== null && _dropdownRef$current$2 !== void 0 ? _dropdownRef$current$2 : 0);
  var threshold = 0;
  var positionTop = windowHeight - (menuHeight + dropdownPosition) < threshold;
  useEffect(function () {
    setWindowHeight(window.innerHeight);

    var resize = function resize() {
      setWindowHeight(window.innerHeight);
    };

    window.addEventListener('resize', resize);
    return function () {
      window.removeEventListener('resize', resize);
    };
  }, []);
  useEffect(function () {
    var _menuRef$current$clie, _menuRef$current;

    setMenuHeight((_menuRef$current$clie = (_menuRef$current = menuRef.current) === null || _menuRef$current === void 0 ? void 0 : _menuRef$current.clientHeight) !== null && _menuRef$current$clie !== void 0 ? _menuRef$current$clie : 0);
  }, [open, props.children]);
  /**
   * To prevent the menu from rendering below,
   * before jumping above we controle the visability state
   */

  useEffect(function () {
    if (menuHeight) {
      setVisibility('visible');
    } else {
      setVisibility('hidden');
    }
  }, [menuHeight]);
  return /*#__PURE__*/React.createElement("div", {
    className: cs('telia-dropdown-content', {
      'telia-dropdown-content__nowrap': !props.wrapContent,
      open: open,
      right: ['right', 'top-right', 'bottom-right'].includes((_props$position = props.position) !== null && _props$position !== void 0 ? _props$position : '')
    }, props.className),
    style: !['bottom-right', 'bottom-left'].includes((_props$position2 = props.position) !== null && _props$position2 !== void 0 ? _props$position2 : '') && positionTop || ['top-right', 'top-left'].includes((_props$position3 = props.position) !== null && _props$position3 !== void 0 ? _props$position3 : '') ? {
      transform: "translateY(calc(-100% - ".concat((_dropdownRef$current$3 = dropdownRef === null || dropdownRef === void 0 ? void 0 : (_dropdownRef$current3 = dropdownRef.current) === null || _dropdownRef$current3 === void 0 ? void 0 : _dropdownRef$current3.offsetHeight) !== null && _dropdownRef$current$3 !== void 0 ? _dropdownRef$current$3 : 0, "px - 2px))")
    } : {
      visibility: visibility
    },
    ref: menuRef,
    tabIndex: -1
  }, allItems);
};